<template>
  <article class="card">
    <CardHeader>
      <span v-text="`${blogPrivacyText} Blog Post`" />
      <span
        v-if="blog.attributes.status === 'published' || blog.attributes.status === 'archived'"
        v-text="`Posted ${publicationDate}`"
      />
      <span
        v-else
        v-text="`Publication Date: ${publicationDate}`"
      />
      <strong>
        <AuthorName
          :full-name="blog.author.attributes.full_name"
          :is-a-shared-copy="blog.attributes.is_a_shared_copy"
          :sharing-union-name="blog.attributes.sharing_union_name"
        />
      </strong>
      <span v-text="categories" />
      <span v-can="['edit-blog-entries', 'archive-blog-entries', 'delete-blog-entries']">
        <CommPopper
          ref="commPopper"
          :options="{ placement: 'bottom-end' }"
        >
          <div
            slot="content"
            class="flex flex-col"
          >
            <a
              v-can="'edit-blog-entries'"
              :href="editUrl"
              v-text="'Edit'"
            />
            <a
              v-if="blog.attributes.status !== 'archived'"
              v-can="'archive-blog-entries'"
              href="#"
              @click.prevent="$refs.commPopper.close().then($emit('openArchiveModal', blog))"
              v-text="'Archive'"
            />
            <a
              v-can="'share-comms'"
              href="#"
              @click.prevent="$refs.commPopper.close().then($root.openModalWithPayload('sendCommToOrganizationsModal', blog))"
              v-text="'Share with Organization'"
            />
            <a
              v-if="blog.attributes.status === 'archived'"
              v-can="'archive-blog-entries'"
              href="#"
              @click.prevent="$refs.commPopper.close().then($store.commit('communicationOpenRestoreArchivedCommunicationModal', blog))"
              v-text="'Restore'"
            />
            <a
              v-can="'delete-blog-entries'"
              href="#"
              @click.prevent="$refs.commPopper.close().then($emit('openDeleteModal', blog))"
              v-text="'Delete'"
            />
          </div>
        </CommPopper>
      </span>
    </CardHeader>
    <div class="flex flex-col md:flex-row">
      <div
        v-if="blog.attributes.hero_image"
        class="card-hero-image md:max-w-xs"
      >
        <img
          :src="blog.attributes.hero_image"
          alt=""
          class="mx-auto"
        >
      </div>
      <div class="card-content">
        <h3 class="-mb-2">
          <a
            :href="detailsUrl"
            v-text="blog.attributes.title"
          />
        </h3>
        <p v-html="blog.attributes.body_short" />
        <a
          :href="detailsUrl"
          v-text="'Read More'"
        />
      </div>
    </div>
  </article>
</template>

<script type="text/babel">
import CommPopper from './CommPopper'
import CardHeader from './CommunicationCardHeader'
import AuthorName from './SharedCommunicationAuthorName'

export default {
  name: 'BlogEntryCard',
  components: {
    AuthorName,
    CommPopper,
    CardHeader,
  },
  props: {
    blog: {
      type: Object,
      required: true,
    },
  },
  computed: {
    blogPrivacyText() {
      return this.blog.attributes.is_private ? 'Private' : 'Public'
    },
    publicationDate() {
      return this.blog.attributes.publication_date
        ? this.moment(this.blog.attributes.publication_date).format(this.$root.commDateFormat)
        : 'Not Set'
    },
    detailsUrl() {
      return this.$urlGenerator.active(`communications/blog/${this.blog.uuid}`)
    },
    editUrl() {
      return this.$urlGenerator.active(`communications/blog/${this.blog.uuid}/edit`)
    },
    categories() {
      const categoryCount = this.blog.categories.data.length

      if (categoryCount === 0) {
        return
      }

      return categoryCount === 1
        ? 'Category: ' + _.map(this.blog.categories.data, 'attributes.title')
        : 'Categories: ' + _.map(this.blog.categories.data, 'attributes.title').join(', ')
    },
  },
}
</script>
